const defaultRender = (value) => (value ? value : "--");

const getColumns = (items = []) => {
  const baseColumns = [
    {
      title: "Name",
      dataIndex: "name",
      render: defaultRender,
    },
    {
      title: "Contents",
      dataIndex: "count_description",
      render: defaultRender,
    },
    {
      title: "Date Added",
      dataIndex: "addedDate",
      render: defaultRender,
    },
    {
      title: "",
      dataIndex: "actions",
      render: defaultRender,
    },
  ];

  const extraColumns = [
    {
      title: "File Name",
      dataIndex: "service_name_slug",
      render: defaultRender,
    },
    {
      title: "File No",
      dataIndex: "file_number",
      render: defaultRender,
    },
  ];

  const hasFiles = items.some((item) => item?.type === "file");

  if (hasFiles) {
    baseColumns.splice(1, 0, ...extraColumns);
  }

  return baseColumns;
};

export default getColumns;
